import { render, staticRenderFns } from "./Neighborhood.vue?vue&type=template&id=65d95fb0&"
import script from "./Neighborhood.vue?vue&type=script&lang=js&"
export * from "./Neighborhood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports